import { initialState } from './initialState';
import * as actionTypes from './actionTypes';

import {
    createCommonStoreStructure,
    websocketUpdater,
    addPriceToEventsSelections,
    updateEvents,
} from './utils';

/**
 * Common store reducer
 * @todo Do we need to differentiate between update and initialise?
 * @param {*} state the current state
 * @param {*} action the action
 * @returns {*} new state
 */
export default function commonStoreReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.COMMON_REDUX_STORE_INITIALISE:
            addPriceToEventsSelections(action.events);

            return createCommonStoreStructure(action.events, state);
        case actionTypes.COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS:
            return websocketUpdater(action.wsData, state);
        case actionTypes.COMMON_REDUX_STORE_CLEAR:
            return {};
        case actionTypes.COMMON_REDUX_STORE_UPDATE_FROM_BACKEND:
            return updateEvents(action.events, state);
        default:
            return state;
    }
}
